export const BASE_URL = "https://admin.skyportdestinations.com/api/";